import { Badge } from "@/components/ui/badge";
import { TaskPriority } from "@/lib/api/checklist";
import { cn } from "@/lib/utils";

interface PriorityBadgeProps {
  priority: TaskPriority;
  className?: string;
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const getPriorityColor = (priority: TaskPriority) => {
    switch (priority) {
      case TaskPriority.LOW:
        return "bg-green-100 text-green-800 hover:bg-green-200";
      case TaskPriority.MEDIUM:
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200";
      case TaskPriority.HIGH:
        return "bg-orange-100 text-orange-800 hover:bg-orange-200";
      case TaskPriority.CRITICAL:
        return "bg-red-100 text-red-800 hover:bg-red-200";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
    }
  };

  return (
    <Badge 
      variant="secondary" 
      className={cn(getPriorityColor(priority), className)}
    >
      {priority}
    </Badge>
  );
}